import React, { useEffect } from 'react';
import { intl } from 'ehs-react';
import { useWaitingRoomStore } from '../../stores/waitingRoom.store';

export function FinalScreen(): JSX.Element {
  const [cleanupWebsocket] = useWaitingRoomStore(state => [
    state.cleanupWebsocket
  ]);

  useEffect(() => {
    cleanupWebsocket();
  }, [cleanupWebsocket]);

  return (
    <>
      <div className="vvpp-thank-you-logo-label">
        <span className="vvpp-thank-you-logo" />
      </div>
      <div className="vvpp-thank-you-text">
        {intl('virtualvisitpatientportlet.finalpage.merci')}
      </div>
    </>
  );
}
